import actionsGetters from './actions.getters';
import actionsCommands from './actions.commands';
import getters from './getters';
import mutations from './mutations';
import BadgesModel from '@/models/childcare-provider/badges';

export const childcare = {
  namespaced: true,
  state: {
    enrollmentFormsContainer: {
      childcareEnrollmentStep: -1,
      currentChildcareEnrollmentStep: -1,
      household: null,
      programStatement: null,
      familyAmenities: null,
      homeSafety: null,
      location: null,
      parentBookWithApprovalRequest: false,
      availabilitySettings: null,
      acceptedAgeGroups: null,
      hoursOfBusiness: [],
      prices: null,
      cancellationOptions: null,
      policies: [],
      notifications: null,
      providerPolicies: [],
      badges: new BadgesModel(),
    },
    orders: {
      pastOrders: [],
      currentOrders: [],
      upcomingOrders: []
    },
    refreshChildrenList: 0,
    updateFamilyMembers: 0,
    providerForCurrentUser: null,
    acceptBooking: false,
    rejectBooking: false,
  },
  getters,
  actions: { ...actionsCommands, ...actionsGetters },
  mutations
};